import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from 'react';
import { getTourStatus, updateTourStatus } from '../api/OnboardingTours';
import Raven from 'raven-js';
import { TourCompletionStatus } from '../constants/TourCompletionStatus';
import { isOnboardingTourSeleniumRunning } from '../utils/env';
export default function useTourStatus(t0) {
  "use memo";

  const $ = _c(14);
  const {
    tourId
  } = t0;
  const [loading, setLoading] = useState(true);
  let t1;
  if ($[0] !== tourId) {
    t1 = {
      tourKey: tourId,
      status: TourCompletionStatus.INCOMPLETE
    };
    $[0] = tourId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [tourStatus, setTourStatus] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = isOnboardingTourSeleniumRunning();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isRunningOnboardingTourTest = t2;
  let t3;
  let t4;
  if ($[3] !== tourId) {
    t3 = () => {
      if (isRunningOnboardingTourTest) {
        setTourStatus({
          tourKey: tourId,
          status: TourCompletionStatus.COMPLETE
        });
        setLoading(false);
        return;
      }
      getTourStatus(tourId).then(status => {
        setTourStatus(status);
      }).catch(_temp).finally(() => {
        setLoading(false);
      });
    };
    t4 = [tourId, isRunningOnboardingTourTest];
    $[3] = tourId;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[6] !== loading || $[7] !== tourId || $[8] !== tourStatus) {
    t5 = () => {
      if (isRunningOnboardingTourTest) {
        return;
      }
      if (!loading && tourStatus.status !== TourCompletionStatus.COMPLETE) {
        updateTourStatus(tourId, TourCompletionStatus.COMPLETE).catch(_temp2);
      }
    };
    t6 = [loading, tourStatus, tourId, isRunningOnboardingTourTest];
    $[6] = loading;
    $[7] = tourId;
    $[8] = tourStatus;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== loading || $[12] !== tourStatus) {
    t7 = {
      tourStatus,
      loading
    };
    $[11] = loading;
    $[12] = tourStatus;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp2(error_0) {
  Raven.captureException(error_0, {
    fingerprint: ["error updating the tour status"]
  });
}
function _temp(error) {
  Raven.captureException(error, {
    fingerprint: ["error fetching the tour status"]
  });
}